var dom = require('./dom')
exports.DOMImplementation = dom.DOMImplementation
exports.XMLSerializer = dom.XMLSerializer
exports.DOMParser = require('./dom-parser').DOMParser



//////////////////
// WEBPACK FOOTER
// /Users/thijsbrons/Sites/paardenwei/web/app/themes/paardenwei/node_modules/@xmldom/xmldom/lib/index.js
// module id = 64
// module chunks = 0